import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { areaSituacaoAtiva, areaSituacaoInativa } from '../area-situacao';

@Component({
    selector: 'sgt-area-situacao-multiselect',
    templateUrl: './area-situacao-multiselect.component.html',
    styleUrls: ['./area-situacao-multiselect.component.less']
})
export class AreaSituacaoMultiselectComponent implements OnInit {
    /** Situações selecionadas */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações */
    @Output() situacoesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma situação';
    @Input() checked = 'Situação'
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    @Input() isShowAtivo = true;
    @Input() isShowInativo = true;
    // Options
    options: IMultiSelectOption[];


    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-area-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle,
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as situações para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        if (this.isShowAtivo) {
            selects.push({
                id: areaSituacaoAtiva.id,
                name: areaSituacaoAtiva.nome,
                classes: 'multiselect-item-area-situacao multiselect-item-area-situacao-ativo'
            });
        }
        if (this.isShowInativo) {
            selects.push({
                id: areaSituacaoInativa.id,
                name: areaSituacaoInativa.nome,
                classes: 'multiselect-item-area-situacao multiselect-item-area-situacao-inativo'
            });
        }

        this.options = selects;
    }

    /** Ao alterar a seleção das situações */
    onChange() {
        this.situacoesChange.emit(this.situacoes);
    }
}
